import React, { useState, useEffect } from 'react';
import Select from 'components/Form/Select';
import TextField from 'components/Form/TextField';
import Button from 'components/Button';
import { industryList } from 'components/Form/utils/generalFormData';
import { Form } from 'antd';
import RevealContent from 'components/RevealContent';
import { init, saveForm } from 'services/marketoService';
import Text from 'components/Text';
import { getSetCookies } from 'utils/cookieUtility';
import { MainContainer, ProgressiveFormContainer } from './styles';
import { getMarketoFormId } from 'utils/marketo';
import useDefaultSubscribeForm from 'hooks/useDefaultSubscribeForm';

const progressiveForm = ({
  buttonColor,
  dataPosition,
  formValues = {},
  onSubmit,
  buttonTitle,
  handleSubscribe,
  enableNotification,
  notificationStyles,
  notificationMessage = 'Thanks for subscribing!',
  buttonType = 'primary',
  revealProps,
  ...otherProps
}) => {
  const [formErrors, setFormErrors] = useState({});
  const [values, setValues] = useState({
    ...formValues,
  });
  const [formValid, setFormValid] = useState({
    email: 0,
    industry: 0,
  });
  const [isUpdate, setUpdate] = useState(false);
  const [fieldHasValue, toggleFieldHasValue] = useState(false);
  const [active, setActive] = useState(true);
  const marketoFormId = getMarketoFormId(useDefaultSubscribeForm()?.marketoForm);

  useEffect(() => {
    init(marketoFormId);
    const tempValues = getSetCookies(values);
    setValues(tempValues);
  }, []);

  async function handleSubmit(e) {
    if (!formValues['email'] && formValid.email < 1) {
      formValid.email = -1;
      formErrors.email = 'Looks like this field is blank';
      return;
    }
    if (formValues['email'] && !formValues['industry'] && formValid.industry < 1) {
      formValid.industry = -1;
      formErrors.email = 'Missing industry Selection';
      return;
    }

    if (handleSubscribe && values.email) {
      handleSubscribe(values.email);
    }

    if (enableNotification) {
      setActive(false);
      toggleFieldHasValue(false);
    }

    saveToMarketo();

    if (values.email) {
      Bizible.Push('User', {
        eMail: values.email, // required
      });
    }

    dataLayer.push({ event: 'form submitted', form_type: 'Email Capture', ...values });

    onSubmit(
      Object.keys(values).reduce((prev, cur) => {
        const newobj = { ...prev };
        if (values[cur]) {
          newobj[cur] = values[cur];
        }
        return newobj;
      }, {})
    );
  }

  const saveToMarketo = async () => {
    await saveForm({
      ...values,
      LeadSource: '',
      Affiliate_Click_ID__c: '',
      Affiliate_ID__c: '',
      Affiliate_Order_ID__c: '',
      marketoFormId,
    });
  };

  async function checkFieldValidate(id, value) {
    const fieldValidation = formValid;
    const fieldValidationErrors = formErrors;

    fieldValidation[id] = 1;

    fieldValidation[id] = value.length >= 1 ? 1 : -1;
    fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : 'Looks like this field is blank';

    if (fieldValidation[id] === 1) {
      switch (id) {
        case 'email':
          fieldValidation[id] = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? 1 : -1;
          break;
      }

      fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : 'Email is invalid';
    }

    setFormValid(fieldValidation);
    setFormErrors(fieldValidationErrors);
    setUpdate(!isUpdate);

    return fieldValidation[id];
  }

  const onHandleChange = (id, newValue) => {
    const tmpValues = { ...values };
    tmpValues[id] = newValue;
    setValues(tmpValues);
    handleFieldChange(id, tmpValues);
    setActive(true);
    checkFieldValidate(id, newValue);
  };

  const onHandleChangeStep2 = (id, newValue) => {
    const tmpValues = { ...values };
    tmpValues[id] = newValue;
    setValues(tmpValues);
    setActive(true);
    checkFieldValidate(id, newValue);
  };

  const handleFieldChange = (id, values) => {
    values[id] ? toggleFieldHasValue(true) : toggleFieldHasValue(false);
  };

  const handleFocus = () => {
    if (!active) {
      setActive(true);
    }
  };

  return (
    <MainContainer>
      <ProgressiveFormContainer
        data-position={dataPosition || 'Email Capture Form'}
        onFinish={handleSubmit}
        {...otherProps}
      >
        {!formValues['email'] && (
          <>
            <Form.Item className="data-layer-form">
              <TextField
                id="email"
                type="text"
                nameType="Email"
                placeholderText={'Enter email address'}
                values={values}
                formValid={formValid}
                formErrors={formErrors}
                handleChange={onHandleChange}
                handleFocus={handleFocus}
                shadow={true}
              />
            </Form.Item>
            <Form.Item data-position="Form - Submit CTA">
              <Button
                color={buttonColor}
                shadow={true}
                disabled={!active || Object.keys(formErrors).some(x => formValid[x] !== 1)}
                onClick={handleSubmit}
                width="100%"
              >
                {!Array.isArray(buttonTitle) ? buttonTitle : buttonTitle[0]}
              </Button>
            </Form.Item>
          </>
        )}
        {formValues['email'] && !formValues['industry'] && (
          <>
            <Form.Item className="data-layer-form">
              <Select
                id="industry"
                type="select"
                nameType={'Enter Your Industry'}
                placeholder={'Select your industry...'}
                options={industryList.slice(1)}
                values={values}
                formValid={formValid}
                formErrors={formErrors}
                handleChange={onHandleChangeStep2}
                shadow={true}
              />
            </Form.Item>
            <Form.Item data-position="Form - Submit CTA">
              <Button shadow={true} disabled={!active} onClick={handleSubmit} width="100%">
                {!Array.isArray(buttonTitle) ? buttonTitle : buttonTitle[1]}
              </Button>
            </Form.Item>
          </>
        )}
      </ProgressiveFormContainer>
      {revealProps && (
        <RevealContent
          showContent={fieldHasValue}
          content={revealProps.content}
          styles={revealProps.styles}
        />
      )}
      {!active && (
        <Text
          type="p"
          className={notificationStyles ? notificationStyles : 'section-hero--notification'}
          size="normal"
          color="#00bb22"
        >
          {notificationMessage}
        </Text>
      )}
    </MainContainer>
  );
};

export const ProgressiveForm = progressiveForm;

export default ProgressiveForm;
